import type { AppAuthSource } from "~/lib/auth/app-auth";
import type { TelemetryIdentity } from "./events";

export function createCanonicalTelemetryIdentity(input: {
  readonly authenticated: boolean;
  readonly authSource: AppAuthSource;
  readonly canonicalUserId: string | null;
  readonly providerUserId: string | null;
  readonly ready: boolean;
  readonly walletAddress: string | null;
}): TelemetryIdentity {
  const authenticated = input.ready && input.authenticated;
  const canonicalUserId = authenticated ? input.canonicalUserId : null;

  return {
    authenticated,
    authSource: input.authSource,
    canonicalUserId,
    privyUserId:
      canonicalUserId && input.authSource === "privy"
        ? input.providerUserId
        : null,
    walletAddress: canonicalUserId ? input.walletAddress : null,
  };
}
